import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { getRoomsByVenueId } from "../../api/room";
import { clearLocalStorage, setUserInLocalStorage } from "../../utils/cookieService";
import { login, validateToken } from './../../api/user';


export const appSlice = createSlice({
    name: 'app',
    initialState: {
        user: null,
        error: null,
        loading: false,
        roomList: [],
        toggleSideBar: false
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRoomList:(state, action) =>{
            state.roomList = action.payload
        },
        setSideBarToggle:(state, action)=>{
            state.toggleSideBar = !state.toggleSideBar
        }
    }
})

export const {
    setUser,
    setError,
    setLoading,
    setRoomList,
    setSideBarToggle
} = appSlice.actions;

export const setUserOnLogin = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        dispatch(setError(null))
        const result = await login(data);
        setUserInLocalStorage(result.data)
        dispatch(setUser(result.data))
        dispatch(push('/admin/dashboard'))
        dispatch(setLoading(false))
    } catch (error) {
        if (error)
            dispatch(setError(error.message))
        dispatch(setLoading(false))
    }
}

export const validateTokenAction = () => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        dispatch(setError(null))
        const response = await validateToken();
        if(response.data)
        dispatch(setUser(response.data))
        dispatch(setLoading(false))
    } catch (error) {
        clearLocalStorage();
        dispatch(push('/admin/login'))
        dispatch(setUser(null))
        dispatch(setError('Invalid token!'))
        dispatch(setLoading(false))
    }
}
export const setRoomListOnVenueInfo = (venueId) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        dispatch(setError(null))
        const response = await getRoomsByVenueId(venueId);
        if(response.data)
        dispatch(setRoomList(response.data))
        dispatch(setLoading(false))
    } catch (error) {
        dispatch(setError(error.message))
        dispatch(setLoading(false))
    }
}

export const setUserOnUpdate = (user)=> async (dispatch) => {
    if(user){
        dispatch(setUser(user))
    }
}
export default appSlice.reducer;